import FAQs from "../../../../src/components/faqs";
import * as React from 'react';
export default {
  FAQs,
  React
};